var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.3 0H17.7C7.8 0 0 7.8 0 17.7v464.6c0 9.9 7.8 17.7 17.7 17.7h305.8c9.8 0 17.7-7.8 17.7-17.7 0-9.8-7.9-17.6-17.7-17.6H35.3V35.3h429.4v63.3c0 9.9 7.8 17.7 17.6 17.7 9.9 0 17.7-7.8 17.7-17.7v-81C500 7.9 492 0 482.3 0zM482.3 383.7c-9.8 0-17.6 7.8-17.6 17.7v63.3h-46c-9.8 0-17.6 7.8-17.6 17.6 0 9.9 7.8 17.7 17.7 17.7h63.5c9.9 0 17.7-7.8 17.7-17.7v-81c0-9.8-8-17.6-17.7-17.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478 244.7l-82.7-63a6.4 6.4 0 0 0-10.3 5v45.6H199.6c-9.9 0-17.7 7.9-17.7 17.7 0 9.8 7.8 17.7 17.7 17.7H385v45.6c0 5.3 6 8.3 10.3 5l82.8-63.3c3.5-2.5 3.5-7.5 0-10.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e8a4ee4a.svg";
export { ForwardRef as ReactComponent };